export const getAsREM = (fontSize: number) : number => {
  return fontSize / 16;
};
